import { render, staticRenderFns } from "./EventsMore.vue?vue&type=template&id=65e9482a&"
import script from "./EventsMore.vue?vue&type=script&lang=js&"
export * from "./EventsMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports